import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import {applyMiddleware, createStore} from "redux";
import thunk from "redux-thunk";
import createSagaMiddleware from 'redux-saga'
import {Provider} from "react-redux";
import './index.css';
import App from './App';
import {handleNewProjectSaga} from './sagas'

import reducer from "./reducers"


// Create Store
const sagaMiddleware = createSagaMiddleware();
// Uncomment to debug store using ReduxDev Tools
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const store = createStore(reducer, composeEnhancers(applyMiddleware(sagaMiddleware, thunk)));
const store = createStore(reducer, applyMiddleware(sagaMiddleware, thunk));

// Start Saga
sagaMiddleware.run(handleNewProjectSaga);

ReactDOM.render(
    <Provider store={store}>
        <App store={store}/>
    </Provider>,
    document.getElementById("root")
);